import React, { Component } from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import validate from './validation';
import { renderCheckbox, renderInput, renderSpecialInput, renderRadio, fields } from './Fields';


class CasoFormStep3 extends Component{
    constructor(props) {
        super(props);
        let fieldsForm = fields.stepThree.fields.map(item => {
            item.active = this.props.summary[_.snakeCase(item.name)] || false;
            item.items.map(subitem => {
                subitem.input = this.props.summary[_.snakeCase(subitem.name + " " + item.name)] || false;
                return subitem;
            })
            return item;
        });
        let auxForm = fields.stepThree.aux.items.map(item => {
            item.active = this.props.summary[_.snakeCase(item.name)] || false;
            item.items.map(subitem => {
                subitem.input = this.props.summary[_.snakeCase(subitem.name + " " + item.name)] || false;
                return subitem;
            })
            return item;
        });
        this.state = {
            fieldsForm,
            aux: this.props.summary.aux,
            auxForm
        }
    }
    selectRadio(indexGroup, indexItem){
        let fieldsForm = this.state.fieldsForm
        fieldsForm[indexGroup].items[indexItem].input = true
        this.setState({ fieldsForm })
    }
    createSubFields(group, position, fieldGroup, change){
        if(group.desc && group.items.length === 0) {
            return (
                <div className="col-md-6" key={group.name + position}>
                    <Field
                        label={group.desc}
                        style={{display: "none"}}
                        name={_.snakeCase(group.name + "Text")}
                        type="text"
                        component={renderSpecialInput}
                    />
                </div>
            )
        } else if(group.type === "group") {
            return group.items.map((item, index) => (
                <div className="col-md-6" key={group.name + index}>
                    <h6>{item.name}</h6>
                    {item.items.map((groupitem, i) => {
                        if(groupitem.items){
                            return (
                                <div key={_.snakeCase(item.name + " " + groupitem.name)}>
                                    <span className="sub-item-title">{groupitem.name}</span>
                                    {groupitem.items.map((subitem, i) => {
                                        return (
                                            <Field
                                                key={_.snakeCase(group.name + " " + item.name + " " + groupitem.name + " " + subitem.name)}
                                                name={_.snakeCase(group.name + " " + groupitem.name + " " + subitem.name)}
                                                component={renderCheckbox}
                                                col="form-check-inline"
                                                label={subitem.name}
                                                id={subitem.name}
                                            />
                                        )
                                    })}
                                </div>
                            )
                        }else{
                            let indexGroup = _.findIndex(this.state.fieldsForm, ['name', group.name]);
                            let itemsAct = this.state.fieldsForm[indexGroup].items;
                            let indexItem = _.findIndex(itemsAct, ['name', item.name])
                            let inputAct = itemsAct[indexItem].input


                            let isDisabled = () => {
                                if(this.props.summary[_.snakeCase(group.name + " " + item.name + "Text")]){
                                    return false
                                }else{
                                    return !inputAct
                                }
                            }

                            if(item.items.length-1 === i){
                                return[
                                    <Field
                                        key={_.snakeCase(group.name + " " + item.name + " " + groupitem.name)}
                                        name={_.snakeCase(group.name + " " + item.name)}
                                        component={renderRadio}
                                        type="radio"
                                        value={groupitem.name}
                                        label={groupitem.name}
                                        id={groupitem.name}
                                        onChange={this.selectRadio.bind(this, indexGroup, indexItem)}
                                    />,
                                    <div className="col-md-12" key={group.name + i}>
                                        <Field
                                            label={group.desc}
                                            disabled={isDisabled()}
                                            style={{display: "none"}}
                                            name={_.snakeCase(group.name + " " + item.name + "Text")}
                                            type="text"
                                            component={renderSpecialInput}
                                        />
                                    </div>
                                ]
                            }else{
                                return (
                                    <Field
                                        key={_.snakeCase(group.name + " " + item.name + " " + groupitem.name)}
                                        name={_.snakeCase(group.name + " " + item.name)}
                                        component={renderRadio}
                                        type="radio"
                                        value={groupitem.name}
                                        label={groupitem.name}
                                        id={groupitem.name}
                                        onChange={this.selectRadio.bind(this, indexGroup, indexItem)}
                                    />
                                )
                            }
                        }
                    })}
                </div>
            ));
        } else {
            return group.items.map( (item, index) => (
                <div className="col-md-6" key={item.name + index + position}>
                    <Field
                        disabled={!item.active}
                        name={_.snakeCase(item.name+this.state[fieldGroup][position].name)}
                        component={renderCheckbox}
                        label={item.name}
                        id={item.name}
                        onChange={() => {
                            let newState = this.state[fieldGroup]
                            newState[position].items[index].input = !item.input
                            change(_.snakeCase(item.name+this.state[fieldGroup][position].name+"Text"), null)
                            this.setState({ fieldGroup: newState })
                        }}
                    />
                    <Field
                        style={{display:"none"}}
                        disabled={!item.input}
                        placeholder={item.placeholder || null}
                        name={_.snakeCase(item.name+this.state[fieldGroup][position].name+"Text")}
                        type="text"
                        component={renderSpecialInput}
                    />
                </div>
            ));
        }
    }

    render(){
        const { invalid, submitFailed, change } = this.props

        return(
            <form onSubmit={this.props.handleSubmit}>
                <div className="row">
                    {this.state.fieldsForm.map((group, i) => {
                        let selectGroup = (e) => {
                            console.log(e);
                            let newState = this.state.fieldsForm
                            newState[i].active = e.target.type === "radio" ? e.target.value === "si" : !group.active
                            this.setState({fieldsForm: newState})
                        }
                        return (
                            <div className="col-md-6" key={i}>
                                <h5>
                                    { group.type === "radio"
                                        ?
                                            <div className="options">
                                                <span className="title">
                                                    {group.name}
                                                </span>
                                                <Field
                                                    name={_.snakeCase(group.name)}
                                                    component={renderRadio}
                                                    label="Si"
                                                    type="radio"
                                                    value="si"
                                                    onChange={selectGroup}
                                                />

                                                <Field
                                                    name={_.snakeCase(group.name)}
                                                    component={renderRadio}
                                                    label="No"
                                                    type="radio"
                                                    value="no"
                                                    onChange={selectGroup}
                                                />
                                            </div>
                                        :
                                            <Field
                                            name={_.snakeCase(group.name)}
                                            component={renderCheckbox}
                                            label={group.name}
                                            id={group.name}
                                            onChange={selectGroup}
                                            />
                                    }

                                </h5>
                                <div className="form-row">
                                    {(group.active === true
                                    || (group.type === "radio" && group.active === "si")
                                    || !this.props.summary[_.snakeCase(group.name)] === "no") &&
                                        this.createSubFields(group, i, "fieldsForm", change)}
                                </div>
                            </div>
                        )
                    })
                    }
                    <div className="col-md-12">
                        <h4>
                            Elementos auxiliares:
                            {invalid && submitFailed && !this.state.aux && <span className="text-danger">Campo requerido</span> }
                            {invalid && submitFailed && this.state.aux && !_.some(this.state.auxForm, { 'active': true }) && <span className="text-danger">Indique al menos un elemento auxiliar</span> }
                            <div className="options">
                                <div className="form-check form-check-inline">
                                    <label className="form-check-label">
                                        <Field
                                            name="aux"
                                            component="input"
                                            type="radio"
                                            value="no"
                                            onChange={()=>{
                                                this.setState({aux: "no"})
                                                let auxForm = this.state.auxForm;
                                                auxForm.map(group => {
                                                    group.active = false
                                                    let propName = _.snakeCase(group.name)
                                                    change(propName, null)
                                                    group.items.forEach(item => {
                                                        item.input = false
                                                        let itemName = _.snakeCase(item.name + " " + group.name)
                                                        let itemNameText = _.snakeCase(item.name + " " + group.name + "Text")
                                                        change(itemName, null)
                                                        change(itemNameText, null)
                                                    })
                                                })
                                                this.setState({ auxForm })
                                            }}
                                        /> Colocación elementos auxiliares donde sea necesario
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <label className="form-check-label">
                                        <Field
                                            name="aux"
                                            component="input"
                                            type="radio"
                                            value="si"
                                            onChange={()=>{
                                                this.setState({ aux: "si" })
                                            }}
                                        /> Indicación expresa de elementos auxiliares
                                    </label>
                                </div>
                            </div>
                        </h4>
                    </div>
                    {this.state.auxForm.map((group, i) => {
                        let selectGroup = () => {
                            let newState = this.state.auxForm
                            newState[i].active = !group.active
                            this.setState({auxForm: newState})
                        }
                        return (
                            <div className="col-md-6" key={i}>
                                <h5>
                                    <Field
                                        name={_.snakeCase(group.name)}
                                        component={renderCheckbox}
                                        label={group.name}
                                        id={group.name}
                                        disabled={group.disabled && this.state.aux !== "si"}
                                        onChange={selectGroup}
                                    />
                                </h5>
                                <div className="form-row">
                                    {group.active && this.state.aux === "si" && this.createSubFields(group, i, "auxForm", change)}
                                </div>
                            </div>
                        )
                    })
                    }
                </div>

                <div className="form-actions">
                    <button type="submit" onClick={this.props.previousPage} className="btn btn-secondary next">
                        <i className="fa fa-chevron-left"></i>
                        &nbsp; Anterior
                    </button>
                    <button type="submit" className="btn btn-primary next float-right">
                        Siguiente &nbsp;
                        <i className="fa fa-chevron-right"></i>
                    </button>
                </div>
            </form>
        )
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
            actions: bindActionCreators({
                change
            }, dispatch)
    };
}
CasoFormStep3 = connect(
    mapDispatchToProps
)(CasoFormStep3);

export default reduxForm({
    form: 'wizard', //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
})(CasoFormStep3);



// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/newcaso/CasoFormStep3.jsx